require("../../site/scripts/service-worker-registrator.js");

require("../../site/scripts/site.js");
require("../../site/scripts/navigation.js");
require("../../site/scripts/searcher.js");
require("../../site/scripts/lazy-charts.js");
require("../../site/scripts/lazy-google-analytics.js");
require("../../site/scripts/lazy-google-adsense.js");
require("../../site/scripts/heatmap-generator.js");

